import { useData } from "data/data-provider";

/** The same / different drop-off switch, one handler for every place that offers it: the location
 *  list's "+ Different dropoff location" / "Same as pickup location" (1NOW-11154) and the top bar's
 *  return switch (1NOW-11153). Different opens the drop-off field and keeps the pick-up: on Design
 *  B's results page an empty pick-up sends the renter home. Same closes it and clears the separate
 *  drop-off, so the drop-off is the pick-up again (dropoffLocationType true) and the search carries
 *  no other drop-off or its fee. */
export const useReturnSwitch = () => {
  const d = useData();
  const isDifferent = d.dropoffLocationType === false;
  const canSwitch = d.ourLocation.some(
    (loc) =>
      loc.active !== false &&
      (loc.location_type === "drop_off" || loc.location_type === "both"),
  );
  const toggle = () => {
    if (isDifferent) {
      d.setDropoffLocationType(true);
      d.setSameDropoffLocation(true);
      d.setDropoffLocation(null);
      d.setSearchedDropoffLocation("");
      // Only a drop-off chosen: it becomes the one location.
      if (!d.pickupLocation && d.dropOffLocation) {
        d.setPickupLocation(d.dropOffLocation);
        d.setSearchedPickupLocation(d.dropOffLocation.name ?? "");
      }
      return;
    }
    d.setDropoffLocationType(false);
    d.setSameDropoffLocation(false);
    const active = d.ourLocation.filter((loc) => loc.active !== false);
    if (active.length === 1) {
      d.setPickupLocation(active[0]);
      d.setDropoffLocation(active[0]);
      d.setSearchedPickupLocation(active[0].name ?? "");
      d.setSearchedDropoffLocation(active[0].name ?? "");
    }
  };
  return { isDifferent, canSwitch, toggle };
};
